import React from 'react'
import { Flex } from 'reflexbox'

export default ({ variant, children, ...props }) => (
  <Flex as="h2" tx="text" variant="heading" alignItems="center" {...props}>
    {children}
  </Flex>
)
